import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Grid, Switch, Typography } from "@mui/material";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { FormField } from "ui/Scripts/source/components/framework/FormField";

export interface IReportFilterPanelShowInFrontPageProp {
    title: string;
    showInFrontPage: boolean;
    onChangeShowInFrontPage: (showInFrontPage: boolean) => void;
}

export const ReportFilterPanelShowInFrontPage = (props: IReportFilterPanelShowInFrontPageProp) => {
    return (
        <div>
            <Typography variant="h6">{Translations.FrontPage}</Typography>
            <div>
                <GridRow>
                    <Grid item sm={12}>
                        <FormField title={props.title} margin="0">
                            <Switch
                                checked={props.showInFrontPage}
                                onChange={e => props.onChangeShowInFrontPage(e.target.checked)}
                            />
                        </FormField>
                    </Grid>
                </GridRow>
            </div>
        </div>
    );
};
